import { HIGH_SCORE, LOW_SCORE, MEDIUM_SCORE } from '../../helpers';

const minValue = 1;
const maxValue = 7;

export const EFFECT_SCORE_COLORS = {
  belowLow: '#EB9E9F',
  lowToMedium: '#EEB89A',
  mediumToHigh: '#6AA6C4',
  aboveHigh: '#56C6AD',
};

export const getScoreColor = (
  score: number,
  low: number = LOW_SCORE,
  high: number = HIGH_SCORE,
  medium: number = MEDIUM_SCORE
) => {
  if (score > high) {
    return EFFECT_SCORE_COLORS.aboveHigh;
  } else if (score >= medium) {
    return EFFECT_SCORE_COLORS.mediumToHigh;
  } else if (score >= low) {
    return EFFECT_SCORE_COLORS.lowToMedium;
  } else {
    return EFFECT_SCORE_COLORS.belowLow;
  }
};

export const getWidthPercentage = (score: number) => {
  const adjustedScore = score - minValue;
  const range = maxValue - minValue;

  const widthPercentage = (adjustedScore / range) * 100;
  return widthPercentage;
};

export const getFlagsPercentage = (value: number = 0) => {
  const adjustedScore = value - minValue;
  const range = maxValue - minValue;
  const flagsPercentage = (adjustedScore / range) * 100;
  return flagsPercentage;
};

export const getVariationValues = (respondentMin: number, respondentMax: number) => {
  const middleValue = (respondentMax - 1 + respondentMin - 1) / 2;
  const range = maxValue - minValue;
  const variationPosition = (middleValue / range) * 100;
  const variationWidth = ((respondentMax - respondentMin) / range) * 100;
  return { variationPosition, variationWidth };
};
